const th = {
  // Header
  nav_home: 'หน้าแรก',
  nav_booking: 'จองเลย',
  nav_therapists: 'นักบำบัด',
  menu_label: 'เมนู',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'สัมผัสประสบการณ์\nนวดไทยที่ดีที่สุด',
  hero_subtitle: 'จองนวดพรีเมียมกับนักบำบัดมืออาชีพในพัทยา ภูเก็ต กรุงเทพฯ และโคราช',
  hero_book_now: 'จองเลย',
  hero_view_therapists: 'ดูนักบำบัด',
  stat_therapists: 'นักบำบัดมืออาชีพ',
  stat_locations: 'พื้นที่ให้บริการ',
  stat_rating: 'คะแนนเฉลี่ย',

  // Features
  feature_gps_title: 'ตรวจจับ GPS อัตโนมัติ',
  feature_gps_desc: 'ค้นหาพื้นที่ใกล้เคียงจากตำแหน่งปัจจุบันของคุณโดยอัตโนมัติ',
  feature_booking_title: 'จองง่ายๆ',
  feature_booking_desc: 'จองนวดได้ง่ายๆ เพียง 5 ขั้นตอน',
  feature_verified_title: 'นักบำบัดที่ผ่านการรับรอง',
  feature_verified_desc: 'นักบำบัดมืออาชีพที่ผ่านการตรวจสอบจากประสบการณ์และรีวิว',

  // Nearby therapists section
  nearby_title: 'นักบำบัดใกล้คุณ',
  nearby_subtitle: 'แนะนำนักบำบัดที่ใกล้ที่สุดตามตำแหน่ง GPS ของคุณ',
  nearby_loading: 'กำลังตรวจหาตำแหน่งของคุณ...',
  nearby_error: 'ไม่สามารถตรวจหาตำแหน่งได้',
  nearby_retry: 'ลองอีกครั้ง',
  nearby_distance: 'ห่าง {distance} กม.',
  nearby_book: 'จองเลย',

  // Locations section
  section_locations_title: 'พื้นที่ที่สามารถจองได้',
  section_locations_subtitle: 'เราให้บริการใน 5 เมืองหลักของประเทศไทย',
  loc_book: 'จองเลย',

  // Courses section
  section_courses_title: 'คอร์สนวด',
  section_courses_subtitle: 'สำรวจโปรแกรมนวดที่หลากหลายของเรา',

  // Therapists section
  section_therapists_title: 'นักบำบัดยอดนิยม',
  section_therapists_subtitle: 'พบกับนักบำบัดที่มีคะแนนสูงสุดของเรา',
  view_all_therapists: 'ดูนักบำบัดทั้งหมด',

  // CTA
  cta_title: 'จองตอนนี้เลย',
  cta_subtitle: 'ประสบการณ์นวดไทยที่ดีที่สุดรอคุณอยู่',
  cta_book: 'จองเลย',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. All rights reserved.',

  // Booking Steps
  step_location: 'เลือกพื้นที่',
  step_course: 'เลือกคอร์ส',
  step_therapist: 'นักบำบัด',
  step_datetime: 'วันที่/เวลา',
  step_confirm: 'ยืนยัน',

  // Booking - Step 1
  booking_location_title: 'กรุณาเลือกพื้นที่',
  booking_location_desc: 'เลือกพื้นที่ที่คุณต้องการรับบริการนวด',
  gps_detect: 'ตรวจจับตำแหน่งอัตโนมัติ',
  gps_loading: 'กำลังตรวจจับตำแหน่ง...',

  // Booking - Step 2
  booking_course_title: 'กรุณาเลือกคอร์สนวด',
  booking_course_desc: 'เลือกประเภทนวดและระยะเวลาที่ต้องการ',
  duration_min: '{min} นาที',

  // Booking - Step 3
  booking_therapist_title: 'กรุณาเลือกนักบำบัด',
  booking_therapist_desc: 'นักบำบัดที่ให้บริการใน{location}',
  no_therapist: 'ไม่มีนักบำบัดสำหรับพื้นที่และคอร์สที่เลือก',
  no_therapist_suggest: 'กรุณาเลือกคอร์สอื่น',

  // Booking - Step 4
  booking_datetime_title: 'กรุณาเลือกวันที่และเวลา',
  booking_datetime_desc: 'เลือกวันที่และเวลาที่ต้องการจอง',
  date_select: 'เลือกวันที่',
  time_select: 'เลือกเวลา',
  time_placeholder: 'กรุณาเลือกวันที่ก่อน',
  time_notice: 'อาจใช้เวลาเดินทางสูงสุด 2 ชั่วโมงขึ้นอยู่กับระยะทาง กรุณาเลือกเวลาที่มีระยะเวลาเพียงพอ',

  // Booking - Step 5
  booking_confirm_title: 'กรุณายืนยันข้อมูลการจอง',
  booking_confirm_desc: 'ตรวจสอบข้อมูลทั้งหมดและกรอกข้อมูลติดต่อ',
  summary_location: 'พื้นที่',
  summary_course: 'คอร์ส',
  summary_price: 'ราคา',
  summary_therapist: 'นักบำบัด',
  summary_date: 'วันที่',
  summary_time: 'เวลา',
  health_check_title: 'ตรวจสอบสุขภาพ',
  health_check_desc: 'หากมีปัญหาสุขภาพ อาการปวด หรือบริเวณที่ต้องการหลีกเลี่ยงการนวด กรุณาแจ้งให้ทราบ',
  health_check_placeholder: 'เช่น มีความดันโลหิตสูง / ไหล่ขวาบาดเจ็บ กรุณานวดเบา ๆ บริเวณร่างกายส่วนบน / มีหมอนรองกระดูกเสื่อม กรุณาข้ามบริเวณหลัง',
  health_check_examples: 'เช่น มีความดันโลหิตสูง / ไหล่ขวาบาดเจ็บ กรุณานวดเบา ๆ บริเวณร่างกายส่วนบน / มีหมอนรองกระดูกเสื่อม กรุณาข้ามบริเวณหลัง',
  contact_title: 'ข้อมูลติดต่อ',
  contact_name: 'ชื่อ',
  contact_name_placeholder: 'กรอกชื่อของคุณ',
  contact_phone: 'เบอร์โทรศัพท์',
  contact_phone_placeholder: 'กรอกเบอร์โทรศัพท์ของคุณ',
  contact_email: 'อีเมล',
  contact_email_placeholder: 'กรอกที่อยู่อีเมลของคุณ',
  contact_note: 'คำขอพิเศษ',
  contact_note_placeholder: 'กรอกคำขอพิเศษหากมี',
  required_mark: '*',

  // Navigation buttons
  btn_prev: 'ย้อนกลับ',
  btn_next: 'ถัดไป',
  btn_complete: 'ยืนยันการจอง',

  // Therapist card
  age_suffix: ' ปี',
  experience_years: 'ประสบการณ์ {years} ปี',

  // Therapist list page
  tl_title: 'นักบำบัด',
  tl_subtitle: 'พบกับนักบำบัดชั้นนำที่ผ่านการรับรองจากประสบการณ์และความเชี่ยวชาญ',
  tab_all: 'ทั้งหมด',

  // Confirmation page
  conf_empty_title: 'ไม่มีข้อมูลการจอง',
  conf_empty_desc: 'กรุณาทำการจองจากหน้าจอง',
  conf_empty_btn: 'จองเลย',
  conf_success_title: 'การจองเสร็จสมบูรณ์!',
  conf_success_subtitle: 'ข้อมูลการจองของคุณได้รับการยืนยันแล้ว ขอบคุณ',
  conf_preparation_title: 'ยังไม่ได้รับการจอง',
  conf_preparation_subtitle: 'บริการอยู่ระหว่างการเตรียมการ การจองยังไม่ได้รับการยืนยัน เราจะติดต่อกลับเมื่อเปิดให้บริการอย่างเป็นทางการ',
  conf_preparation_notice: 'บริการอยู่ระหว่างการเตรียมการ การจองนี้ยังไม่ใช่การจองที่ได้รับการยืนยัน',
  conf_booking_id: 'หมายเลขการจอง',
  conf_detail_title: 'รายละเอียดการจอง',
  conf_label_location: 'พื้นที่',
  conf_label_course: 'คอร์สนวด',
  conf_label_price: 'ราคา',
  conf_label_therapist: 'นักบำบัด',
  conf_label_date: 'วันที่',
  conf_label_time: 'เวลา',
  conf_label_email: 'อีเมล',
  conf_label_contact: 'ข้อมูลติดต่อ',
  conf_label_note: 'คำขอพิเศษ',
  conf_notice_title: 'ข้อควรทราบ',
  conf_notice_1: 'อาจใช้เวลาเดินทางสูงสุด 2 ชั่วโมงขึ้นอยู่กับระยะทาง',
  conf_notice_2: 'กรุณาติดต่อทางโทรศัพท์หากต้องการเปลี่ยนแปลงหรือยกเลิกการจอง',
  conf_notice_3: 'สามารถชำระเงินด้วยเงินสดหรือบัตรที่หน้างาน',
  conf_btn_home: 'หน้าแรก',
  conf_btn_new: 'จองใหม่',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'เบราว์เซอร์ของคุณไม่รองรับ GPS',
  GEO_PERMISSION_DENIED: 'การเข้าถึงตำแหน่งถูกปฏิเสธ กรุณาเลือกพื้นที่ด้วยตนเอง',
  GEO_POSITION_UNAVAILABLE: 'ไม่สามารถใช้ข้อมูลตำแหน่งได้',
  GEO_TIMEOUT: 'คำขอตำแหน่งหมดเวลา',
  GEO_UNKNOWN: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',

  // SEO
  seo_home_title: 'นวดนอกสถานที่ กรุงเทพ และทั่วไทย | Bangkok In Home Massage',
  seo_home_desc: 'หมอนวดมืออาชีพถึงโรงแรมหรือที่พักใน กรุงเทพ พัทยา ภูเก็ต เชียงใหม่ โคราช นวดไทย นวดน้ำมัน นวดอโรม่า จองออนไลน์ง่ายๆ',
  seo_therapists_title: 'นักบำบัดนวดนอกสถานที่ | Bangkok In Home Massage',
  seo_therapists_desc: 'ค้นหาหมอนวดมืออาชีพใน กรุงเทพ พัทยา ภูเก็ต เชียงใหม่ โคราช ดูโปรไฟล์ คะแนน ความเชี่ยวชาญ แล้วจองออนไลน์ได้ทันที',
  seo_booking_title: 'จองนวดนอกสถานที่ออนไลน์ | Bangkok In Home Massage',
  seo_booking_desc: 'เลือกพื้นที่ ประเภทนวด และนักบำบัด เพื่อจองนวดนอกสถานที่ หมอนวดมืออาชีพจะเดินทางไปถึงโรงแรมหรือที่พักของคุณ',

  // Body info
  height_label: 'ส่วนสูง',
  weight_label: 'น้ำหนัก',

  // GPS therapist list
  gps_find_nearby: 'ค้นหานักบำบัดใกล้เคียง',
  gps_nearby_active: 'แสดงตามลำดับใกล้สุด',

  // Notices
  notice_punctual: 'นักบำบัดจะไปตามวันที่และเวลาที่คุณจอง กรุณาเตรียมตัวให้พร้อมตรงเวลา',
  notice_no_sexual: 'บริการนี้เป็นบริการนวดมืออาชีพ ไม่มีบริการทางเพศใดๆ ทั้งสิ้น',

  // Guide section
  guide_title: 'คำแนะนำการใช้บริการ',
  guide_subtitle: 'กรุณาอ่านข้อมูลต่อไปนี้เพื่อประสบการณ์ที่สะดวกสบาย',
  guide_before_title: 'ก่อนรับบริการ',
  guide_before_text: 'แนะนำให้อาบน้ำเบาๆ ก่อนรับบริการ กรุณาหลีกเลี่ยงการนัดหมายทันทีหลังรับประทานอาหาร อาจถูกปฏิเสธบริการหากมึนเมา หากมีโรคประจำตัว (ความดันโลหิตสูง โรคหัวใจ ฯลฯ) หรือตั้งครรภ์ กรุณาระบุในคำขอพิเศษเมื่อจอง',
  guide_booking_title: 'ข้อมูลการจอง',
  guide_booking_text: 'นักบำบัดอาจใช้เวลาเดินทางสูงสุด 2 ชั่วโมงขึ้นอยู่กับระยะทาง กรุณาเลือกเวลาที่มีระยะเวลาเพียงพอ หากต้องการเปลี่ยนแปลงหรือยกเลิกการจอง กรุณาติดต่อทางโทรศัพท์',
  guide_session_title: 'ระหว่างรับบริการ',
  guide_session_text: 'นักบำบัดจะเดินทางไปยังที่พักของคุณตามเวลาที่จอง หากรู้สึกไม่สบายระหว่างรับบริการ กรุณาแจ้งนักบำบัดทันที บริการนี้เป็นบริการนวดมืออาชีพ ไม่มีบริการทางเพศใดๆ ทั้งสิ้น',
  guide_after_title: 'หลังรับบริการ',
  guide_after_text: 'กรุณาดื่มน้ำให้เพียงพอ อาการปวดเมื่อยกล้ามเนื้อหรือเหนื่อยล้าชั่วคราวเป็นเรื่องปกติ จะหายภายใน 2-3 วัน กรุณาหลีกเลี่ยงการดื่มหนักและออกกำลังกายหนักในวันที่รับบริการ',
  guide_payment_title: 'การชำระเงิน',
  guide_payment_text: 'สามารถชำระเงินด้วยเงินสดหรือบัตรที่หน้างาน',

  // FAQ
  faq_q1: 'บริการนวดนอกสถานที่ใช้งานอย่างไร?',
  faq_a1: 'เลือกพื้นที่ เลือกประเภทนวด เลือกนักบำบัด และจองวันเวลา นักบำบัดจะเดินทางไปยังโรงแรมหรือที่พักของคุณ',
  faq_q2: 'ให้บริการในพื้นที่ใดบ้าง?',
  faq_a2: 'เราให้บริการนวดนอกสถานที่มืออาชีพใน 5 พื้นที่ ได้แก่ กรุงเทพฯ พัทยา ภูเก็ต เชียงใหม่ และโคราช',
  faq_q3: 'จะเปลี่ยนแปลงหรือยกเลิกการจองได้อย่างไร?',
  faq_a3: 'กรุณาติดต่อทางโทรศัพท์หากต้องการเปลี่ยนแปลงหรือยกเลิกการจอง สามารถชำระเงินด้วยเงินสดหรือบัตรที่หน้างาน',

  // 404
  notfound_title: 'ไม่พบหน้าเพจ',
  notfound_desc: 'หน้าเพจที่คุณร้องขอไม่มีอยู่หรือถูกย้ายแล้ว',
  notfound_home: 'กลับหน้าหลัก',
};

export default th;
